import { useState, useMemo, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { FormSection, formValueSelector, getFormSyncErrors } from 'redux-form'
import actions from 'redux-form/lib/actions'
import clx from 'classnames'
import _ from 'lodash'
import { Row, Col, Divider } from 'antd'
import { COMMA, idsOnlyParser } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { Icon, Modal, Button, Toast, Loader } from '@vzmi/shp_shared_compo'
import errorHelper from '../../../../../../../../lib/errorHelper'
import { UPDATE_LISTING_FORM_KEY } from '../../../../../../../constants/proposalTypes'
import { removeNotNumberAndComma } from '../../../../../../../lib/parser'
import {
  FormRow,
  RadioGroupInputField,
  TextareaCountField,
  MenuSelectField,
  HyperLink
} from '../../../../../../Common/Form'
import { Field } from '../../../../../../Common/forms'
import { RENDER_ID } from '../../../../../UpdateListing/helpers/converters'
import {
  FORM_SECTION,
  FORM,
  TABLE_TYPE,
  TABLE_GROUP_TYPE,
  TABLE_GROUP_BY_GROUP_SKU,
  ATTR_NAME_LIMIT,
  COLUMN,
  GROUP_SKU_KEY,
  validationChain,
  requiredValidation,
  attrNameValidation,
  idsValidation,
  getIdsFromValue,
  getIdsCountFromValue
} from '../../helper'
import listingModelStyles from '../../../index.css'
import styles from './index.css'
import { delay } from '@vzmi/component_ec_nodejs_util/dist/lib/renderUtil'

const checkToStoreAction = () => false

export const FIELD = {
  TYPE: 'type',
  MODELS: 'models',
  NAME: 'name',
  IDS: 'ids'
}

const COMPLIMENTARY_TYPE_OPTIONS = [
  { value: false, label: '無選項' },
  { value: true, label: '有選項' }
]

export const NEW_COMPLIMENTARIES_FORM = 'newComplimentariesForm'

const INIT_MODEL = {
  [FIELD.NAME]: '',
  [FIELD.IDS]: ''
}

const COMPLIMENTARY_LIMIT = {
  [COMPLIMENTARY_TYPE_OPTIONS[0].value]: {
    [FIELD.IDS]: 99
  },
  [COMPLIMENTARY_TYPE_OPTIONS[1].value]: {
    [FIELD.NAME]: ATTR_NAME_LIMIT,
    [FIELD.IDS]: 20
  }
}

const COMPLIMENTARY_TYPE_LIMIT = {
  [TABLE_TYPE.COMPLIMENTARIES]: COMPLIMENTARY_LIMIT,
  [TABLE_TYPE.SELECT_COMPLIMENTARIES]: COMPLIMENTARY_LIMIT,
  // 加價購只有單層
  [TABLE_TYPE.ADDITIONAL_PURCHASES]: {
    [COMPLIMENTARY_TYPE_OPTIONS[0].value]: {
      [FIELD.IDS]: 20
    }
  }
}

export const FORM_INIT = {
  [FIELD.TYPE]: COMPLIMENTARY_TYPE_OPTIONS[0].value,
  [FIELD.MODELS]: [INIT_MODEL]
}

const form = `${FORM_SECTION}.${NEW_COMPLIMENTARIES_FORM}`

const RuleHint = props => {
  const { openRule, className } = props
  return (
    <p
      className={clx(
        styles.ruleHint,
        { [className]: className }
      )}
    >
      匯入的商品需符合條件，請參考
      <HyperLink onClick={openRule}>
        條件規定
      </HyperLink>
    </p>
  )
}

const NoAttrField = props => {
  const { type, tableType, openRule, getIdsCount: getIdsCountFromInput, isSubmitted } = props
  const { [FIELD.IDS]: idsLimit } = _.get(COMPLIMENTARY_TYPE_LIMIT, `${tableType}.${type}`, {})
  return (
    <FormRow
      label='商品編號'
      labelAlign='top'
      withoutMargin
      withInputCountPaddingBottom
    >
      <Col flex='auto'>
        <RuleHint openRule={openRule} />
        <Field
          name={FIELD.IDS}
          data-role={FIELD.IDS}
          component={TextareaCountField}
          rows={6}
          placeholder={`以逗號或enter分隔,最多輸入${idsLimit}筆`}
          parse={removeNotNumberAndComma}
          validate={idsValidation(idsLimit, getIdsCountFromInput(false))}
          countLimit={idsLimit}
          customizeGetCount={getIdsCountFromInput(true)}
          mustShowFormError={isSubmitted}
          showErrorOnActive
          keepErrorPosition
        />
      </Col>
    </FormRow>
  )
}

const AttrField = props => {
  const {
    type,
    tableType,
    displayNameOptions,
    removeModel,
    modelsSize,
    getIdsCount: getIdsCountFromInput,
    isSubmitted
  } = props
  const {
    [FIELD.NAME]: nameLimit,
    [FIELD.IDS]: idsLimit
  } = _.get(COMPLIMENTARY_TYPE_LIMIT, `${tableType}.${type}`, {})
  const optionLabelMap = _.keyBy(displayNameOptions, 'label')

  const getCustomInputValue = arrayValue => {
    const selectValue = _.get(arrayValue, '0', '')
    const customValue = _.get(optionLabelMap, `${selectValue}.value`, selectValue)
    return customValue
  }

  return (
    <Row align='middle'>
      <Col flex='auto'>
        <FormRow
          label='贈品顯示名稱'
          className={styles.formRow}
          withoutMargin
          withoutPaddingRight
          withInputCountPaddingBottom
        >
          <Col flex='auto'>
            <Field
              name={FIELD.NAME}
              data-role={FIELD.NAME}
              component={MenuSelectField}
              options={displayNameOptions}
              validate={requiredValidation}
              customInputValue={v => [getCustomInputValue([v])]}
              customUpdateValue={getCustomInputValue}
              customInputCountLimit={nameLimit}
              validateCustomInput={validationChain(attrNameValidation(nameLimit))}
              enableFilter={false}
              mustShowFormError={isSubmitted}
              closeOnSelect
              closeOnCustomInputSubmit
              editableCustomInput
              enableCustomInput
              enableCustomInputValidation
              enableCustomInputCounter
              showErrorOnActive
              keepErrorPosition
              showOptionLabel
            />
          </Col>
        </FormRow>
        <FormRow
          label='商品編號'
          labelAlign='top'
          withoutMargin
        >
          <Col flex='auto'>
            <Field
              name={FIELD.IDS}
              data-role={FIELD.IDS}
              component={TextareaCountField}
              rows={3}
              placeholder={
                `以逗號或enter分隔,最多輸入${idsLimit}筆\n將自動以第一筆商品資訊做代表顯示於賣場上`
              }
              parse={removeNotNumberAndComma}
              validate={idsValidation(idsLimit, getIdsCountFromInput(false))}
              countLimit={idsLimit}
              customizeGetCount={getIdsCountFromInput(true)}
              mustShowFormError={isSubmitted}
              showErrorOnActive
              keepErrorPosition
            />
          </Col>
        </FormRow>
      </Col>
      <Col
        flex='40px'
        className={styles.actionArea}
      >
        <Button
          buttonType='outline'
          size='small'
          className={clx(
            listingModelStyles.actionBtn,
            listingModelStyles.deleteBtn,
            { [listingModelStyles.visible]: (modelsSize !== 1) },
            listingModelStyles.alwaysVisible
          )}
          onClick={removeModel}
        >
          <Icon
            name='delete'
            size={16}
            align='middle'
            color='#979ba7'
          />
        </Button>
      </Col>
    </Row>
  )
}

const NewComplimentariesModal = props => {
  const {
    dispatch,
    change,
    title,
    tableType,
    isFormErrorExist,
    rootSyncErrors,
    syncErrors,
    sectionFormValues = {},
    formValues = {},
    sortedSpecs,
    displayNameOptions,
    visible,
    setVisible,
    openImportRuleModal,
    fetchImportExtraModels
  } = props
  const {
    [tableType]: complimentaries = [],
    [FORM[tableType]]: extraModelsFormValues = {},
    [TABLE_GROUP_TYPE[tableType]]: complimentaryGroups = [],
    [TABLE_GROUP_BY_GROUP_SKU[tableType]]: groupMapByGroupSku = {}
  } = sectionFormValues
  const {
    [FIELD.TYPE]: type,
    [FIELD.MODELS]: models = []
  } = formValues
  const isNoAttr = !type
  const modelsSize = _.size(models)
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const prevVisible = useRef(false)

  const getIdsCount = (isInputProps = true) => target => getIdsCountFromValue(target, isInputProps)

  const onOk = async () => {
    setIsSubmitted(true)
    const groupDuplicatedError = getGroupDuplicatedError()
    if (!_.isEmpty(groupDuplicatedError)) {
      updateSyncErrors(groupDuplicatedError)
      return
    }

    if (isFormErrorExist) {
      return
    }

    setIsLoading(true)
    // 取得要匯入的商品
    const [message, payload = {}] = await fetchImportExtraModels(formValues)
    if (!_.isEmpty(message)) {
      Toast.error(message)
      setIsLoading(false)
      return
    }

    const {
      allowedSkuList = [],
      products = []
    } = payload

    const isImportSuccess = !_.isEmpty(allowedSkuList)
    const allowedSkuMap = _.keyBy(allowedSkuList)
    if (isImportSuccess) {
      const isAdditionalPurchases = (tableType === TABLE_TYPE.ADDITIONAL_PURCHASES)
      const productMapBySku = _.keyBy(products, COLUMN.ID)
      // renderId 頁面載入後就不會變當作 primary key 使用
      // 為了避免刪除既有商品取最大值當預設值往下加
      const nextRenderIndex = _.flow(
        () => _.keys(extraModelsFormValues),
        renderIds => _.max([...renderIds.map(Number), 0]),
        maxId => maxId + 1
      )()
      const totalNewComplimentaries = _.flow(
        () => _.reduce(models, (collect, model = {}) => {
          const {
            [FIELD.NAME]: groupName,
            [FIELD.IDS]: productIdsStr
          } = model
          const groupSku = _.get(groupMapByGroupSku, `${groupName}.${GROUP_SKU_KEY}`, groupName)
          const currentCollectSize = _.size(collect)
          const newComplimentaries = _.flow(
            () => idsOnlyParser(productIdsStr),
            ids => _.filter(ids, id => (id in allowedSkuMap)),
            filteredIds => _.reduce(filteredIds, (newModels, filteredId) => {
              const product = _.get(productMapBySku, filteredId)
              if (_.isUndefined(product)) {
                return newModels
              }

              const groupProps = isNoAttr ? {} : { [GROUP_SKU_KEY]: `${groupSku}` }
              const attrNameProps = _.set({}, COLUMN.ATTR_NAME, _.get(product, COLUMN.NAME))
              const additionalPurchasesProps = {
                ..._.pick(product, [COLUMN.COST]),
                // 廠商建議價在 product 不叫 price
                // https://staging-tw.supplier.yahoo.com/docs/api/resources/product/#product-1
                [COLUMN.PRICE]: _.get(product, 'msrp', 0)
              }
              const EXTRA_MODEL_FIELDS = [
                COLUMN.ID,
                COLUMN.NAME,
                COLUMN.DISPLAY_NAME,
                COLUMN.ATTR_NAME,
                COLUMN.STOCK,
                COLUMN.AVAILABLE_COUNT,
                COLUMN.PART_NO
              ]
              const newModel = {
                // 匯入的商品要組成 extra model 格式需要額外從 products 拿資料
                ..._.pick(product, EXTRA_MODEL_FIELDS),
                // 加入 SHORT_TITLE，其值為 product 的 NAME 值
                [COLUMN.SHORT_TITLE]: product[COLUMN.NAME],
                // 加價購欄位
                ...(isAdditionalPurchases && additionalPurchasesProps),
                // 有屬性商品加上 groupSku
                ...groupProps,
                // 商品名稱補成屬性名稱
                ...attrNameProps,
                [RENDER_ID]: `${nextRenderIndex + _.size(newModels) + currentCollectSize}`
              }
              newModels.push(newModel)
              return newModels
            }, [])
          )()
          collect = [...collect, ...newComplimentaries]

          return collect
        }, []),
        newComplimentaries => {
          const {
            // 無屬性
            undefined: newNoAttrComplimentaries = [],
            // 有屬性
            ...complimentariesGroupBySpec
          } = _.groupBy(
            [
              // isNew flag 判斷既有或匯入 extra models
              // isNewImport flag 用於判斷是否屬於 "這次" 的新匯入 extra models，用於排序重複匯入相同編號
              ...complimentaries.map(complimentary => ({ [COLUMN.IS_NEW]: false, ...complimentary, [COLUMN.IS_NEW_IMPORT]: false })),
              ...newComplimentaries.map(complimentary => ({ ...complimentary, [COLUMN.IS_NEW]: true, [COLUMN.IS_NEW_IMPORT]: true }))
            ],
            complimentary => {
              const {
                [RENDER_ID]: renderId,
                [COLUMN.IS_NEW]: isNew,
                [COLUMN.IS_NEW_IMPORT]: isNewImport,
                [GROUP_SKU_KEY]: groupSku
              } = complimentary
              const attrName = _.get(complimentary, COLUMN.ATTR_NAME, '')
              // 為了維持既有商品順序
              // 無屬性既有商品按照 spec.selectedValue 分群、新匯入不分群會放到最後
              if (_.isUndefined(groupSku)) {
                return (isNew && isNewImport) ? 'undefined' : `${attrName}-${renderId}`
              }
              // 有屬性商品都看 groupSku 分群
              return _.get(groupMapByGroupSku, `${groupSku}.${COLUMN.GROUP_NAME}`)
            }
          )
          const newSortedComplimentaries = [
            ..._.concat(
              ..._.flow(
                // 從匯入前無屬性和有屬性的排序按照分群依序重新排列商品
                () => _.map(sortedSpecs, sortedSpec => {
                  const {
                    spec,
                    isNoAttr,
                    [RENDER_ID]: renderId
                  } = sortedSpec
                  const groupKey = isNoAttr ? `${spec}-${renderId}` : spec
                  return _.get(complimentariesGroupBySpec, groupKey, [])
                })
              )()
            ),
            // 新匯入無屬性商品沒有分群擺最後
            ...newNoAttrComplimentaries
          ]
          return newSortedComplimentaries
        }
      )()
      // 重組有屬性群組列表
      const totalNewComplimentaryGroup = [
        ...complimentaryGroups,
        ..._.flow(
          () => _.filter(models, model => !(model[FIELD.NAME] in groupMapByGroupSku)),
          filteredModels => _.map(filteredModels, filteredModel => {
            const groupName = _.get(filteredModel, FIELD.NAME, '')
            return {
              [COLUMN.GROUP_NAME]: groupName,
              [GROUP_SKU_KEY]: groupName
            }
          })
        )()
      ]
      const newGroupMapByGroupSku = _.keyBy(totalNewComplimentaryGroup, GROUP_SKU_KEY)
      const newFormValues = _.keyBy(totalNewComplimentaries, RENDER_ID)
      // 一次把匯入後要調整的欄位寫入
      change(FORM_SECTION, {
        ...sectionFormValues,
        [tableType]: totalNewComplimentaries,
        [FORM[tableType]]: newFormValues,
        [TABLE_GROUP_TYPE[tableType]]: totalNewComplimentaryGroup,
        [TABLE_GROUP_BY_GROUP_SKU[tableType]]: newGroupMapByGroupSku
      })
      Toast.success(`${title}匯入成功`)
    }

    // 根據 allowedSkuMap 過濾掉表單中有找到的編號，剩下的都是失敗的有無屬性商品
    const invalidModels = _.flow(
      () => _.reduce(models, (newModels, model) => {
        const ids = _.flow(
          () => idsOnlyParser(_.get(model, FIELD.IDS, '')),
          _.compact
        )()
        const invalidIds = _.filter(ids, id => !(id in allowedSkuMap))
        if (_.isEmpty(invalidIds)) {
          return newModels
        }

        const isAllIdsInvalid = _.isEqual(ids, invalidIds)
        const newModel = {
          ...model,
          [FIELD.IDS]: _.join(invalidIds, COMMA),
          isAllIdsInvalid
        }
        newModels.push(newModel)
        return newModels
      }, [])
    )()
    if (!_.isEmpty(invalidModels)) {
      change(`${form}.${FIELD.MODELS}`, invalidModels)
    }

    const { unmatchedErrors, totalInvalidIds } = _.flow(
      () => _.get(payload, 'errors', []),
      errors => _.reduce(errors, (collect, error) => {
        const fieldError = _.get(error, 'invalidValue', '')
        // skuCandidates[0]: 6675272
        // ['skuCandidates[0]: 6675272', '6675272']
        const sku = _.get(fieldError.match(/skuCandidates\[*.\]:\s(\d+)/), '1', '')
        const errorMessage = errorHelper.parseErrorMessage(error)
        if (_.isEmpty(sku)) {
          collect.unmatchedErrors.push(errorMessage)
        } else {
          collect.totalInvalidIds.push(sku)
        }
        return collect
      }, { unmatchedErrors: [], totalInvalidIds: [] })
    )()

    // 非針對特定編號的錯誤訊息寫在 toast 上
    if (!_.isEmpty(unmatchedErrors)) {
      const uniqErrorMessages = _.uniq(unmatchedErrors)
      for (const uniqErrorMessage of uniqErrorMessages) {
        Toast.error(uniqErrorMessage)
      }
    }

    // 針對匯入失敗的編號判斷是部分失敗或全失敗顯示錯誤訊息在 textarea 底下
    if (!_.isEmpty(totalInvalidIds)) {
      const fieldErrors = {}
      for (const [index, invalidModel = {}] of invalidModels.entries()) {
        const { isAllIdsInvalid } = invalidModel
        const field = `${FIELD.MODELS}[${index}].${FIELD.IDS}`
        const errorMessage = isAllIdsInvalid
          ? '條件不符合，請重新確認條件規定'
          : `部分不符合條件，請重新確認條件規定，僅匯入符合的${title}`
        _.set(fieldErrors, field, errorMessage)
      }
      updateSyncErrors(fieldErrors)
    }

    setIsLoading(false)

    // 有錯誤訊息不關閉匯入視窗
    if (!_.every([message, unmatchedErrors, totalInvalidIds], _.isEmpty)) {
      return
    }
    onCancel()
  }

  const onCancel = () => setVisible(false)

  const onTypeChange = () => {
    const resetField = FIELD.MODELS
    setIsSubmitted(false)
    change(`${form}.${resetField}`, FORM_INIT[resetField])
  }

  const getGroupDuplicatedError = () => {
    // 無屬性不會分群重複
    if (isNoAttr) {
      return {}
    }

    // 計算有哪些分群重複，組出分群的對應表
    const duplicatedMapByGroupName = _.flow(
      () => _.groupBy(models, FIELD.NAME),
      groupedModels => _.reduce(groupedModels, (duplicatedMap, groupedModels, groupName) => {
        const modelsSize = _.size(groupedModels)
        if (modelsSize === 1) {
          return duplicatedMap
        }

        duplicatedMap[groupName] = groupedModels
        return duplicatedMap
      }, {})
    )()
    const fieldErrors = {}
    // 每一列表單確認，有重複的分群會把錯誤訊息寫入顯示名稱選單下面
    for (const [index, model] of models.entries()) {
      if (!(model[FIELD.NAME] in duplicatedMapByGroupName)) {
        continue
      }

      const field = `${FIELD.MODELS}[${index}].${FIELD.NAME}`
      const errorMessage = '贈品顯示名稱重複'
      _.set(fieldErrors, field, errorMessage)
    }
    return fieldErrors
  }

  const addNewModel = () => {
    const updateField = FIELD.MODELS
    const newModels = [
      ...models,
      INIT_MODEL
    ]
    change(`${FORM_SECTION}.${NEW_COMPLIMENTARIES_FORM}.${updateField}`, newModels)
    setIsSubmitted(false)
  }

  const removeModel = removeIndex => async () => {
    const updateField = FIELD.MODELS
    const newModels = _.filter(models, (model, index) => index !== removeIndex)
    change(`${form}.${updateField}`, newModels)
    await delay(0)
    // 有屬性匯入移除新列後清除該列錯誤訊息
    const newErrors = _.flow(
      () => ({ ...syncErrors }),
      cloneErrors => _.omit(cloneErrors, [`${updateField}[${removeIndex}]`]),
      errors => {
        const fieldErrors = _.get(errors, updateField, [])
        const isFieldErrorExist = _.some(fieldErrors, fieldError => !_.isEmpty(fieldError))
        if (isFieldErrorExist) {
          return errors
        }

        return {}
      }
    )()
    updateSyncErrors(newErrors)
  }

  const updateSyncErrors = (errors = {}) => {
    const syncErrors = { ...rootSyncErrors }
    _.set(syncErrors, form, errors)
    dispatch(actions.updateSyncErrors(UPDATE_LISTING_FORM_KEY, syncErrors))
  }

  const FieldComponent = useMemo(() => {
    if (isNoAttr) {
      return NoAttrField
    }

    return AttrField
  }, [isNoAttr])

  useEffect(() => {
    if (prevVisible.current === visible) {
      return
    }

    prevVisible.current = visible
    if (!visible) {
      return
    }

    setIsSubmitted(false)
  }, [visible])

  return (
    <Modal
      title={`匯入${title}`}
      data-role={`${tableType}ImportModal`}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      checkToStoreAction={checkToStoreAction}
      className={styles.modal}
      width={650}
      okButtonDisabled={isLoading}
      destroyOnClose
    >
      <Loader loaded={!isLoading}>
        <FormSection name={form}>
          {
            (tableType !== TABLE_TYPE.ADDITIONAL_PURCHASES) && (
              <FormRow
                label='贈品屬性'
                labelAlign='top'
                withoutMargin
              >
                <Field
                  name={FIELD.TYPE}
                  data-role={FIELD.TYPE}
                  component={RadioGroupInputField}
                  options={COMPLIMENTARY_TYPE_OPTIONS}
                  onChange={onTypeChange}
                />
              </FormRow>
            )
          }
          {
            !isNoAttr && (
              <RuleHint
                openRule={openImportRuleModal}
                className={styles.withMargin}
              />
            )
          }
          <div
            className={clx(
              { [styles.attrModelsArea]: !isNoAttr },
              { [styles.noAttrModelsArea]: isNoAttr }
            )}
          >
            {models.map((model, index) => {
              const isLastItem = modelsSize === (index + 1)
              return (
                <FormSection
                  name={`${FIELD.MODELS}[${index}]`}
                  data-role={FIELD.MODELS}
                  key={index}
                >
                  <FieldComponent
                    key={index}
                    type={type}
                    tableType={tableType}
                    displayNameOptions={displayNameOptions}
                    getIdsFromValue={getIdsFromValue}
                    getIdsCount={getIdsCount}
                    openRule={openImportRuleModal}
                    removeModel={removeModel(index)}
                    modelsSize={modelsSize}
                    isSubmitted={isSubmitted}
                  />
                  {(!isNoAttr && !isLastItem) && (
                    <Divider />
                  )}
                </FormSection>
              )
            })}
          </div>
          {!isNoAttr && (
            <HyperLink
              onClick={addNewModel}
              data-role='add-new-import-row'
            >
              <Divider />
              <Icon
                name='add-attachments'
                color='#5478fc'
                size={14}
                align='middle'
                style={{ cursor: 'pointer' }}
              />
              {' 新增屬性選項'}
            </HyperLink>
          )}
        </FormSection>
      </Loader>
    </Modal>
  )
}

const selector = formValueSelector(UPDATE_LISTING_FORM_KEY)
const NewComplimentariesModalWithRedux = connect((state, props) => {
  const sectionFormValues = selector(state, FORM_SECTION) || {}
  const formValues = selector(state, form) || {}
  const rootSyncErrors = getFormSyncErrors(UPDATE_LISTING_FORM_KEY)(state) || {}
  const syncErrors = _.flow(
    () => _.get(rootSyncErrors, form, {}),
    errors => _.omitBy(errors, _.isEmpty)
  )()
  const isFormErrorExist = !_.isEmpty(syncErrors)

  const reduxProps = {
    sectionFormValues,
    formValues,
    rootSyncErrors,
    syncErrors,
    isFormErrorExist
  }
  return reduxProps
})(NewComplimentariesModal)

export default NewComplimentariesModalWithRedux
